<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { KsButton } from '@aschehoug/kloss'
import useFullscreen from '~/composables/useFullscreen'

const { t } = useI18n()
const {
  isSupported,
  toggleFullscreen,
  isFullscreen,
  disableFullscreen,
  onFullscreenChange,
  setCurrentFullscreenState,
} = useFullscreen()

const emit = defineEmits<{ fullscreen: [boolean] }>()

const browserWidth = ref<number>()

const buttonBreakpoint = 767 // Allow small tablets to access fullscreen
const ariaLabel = computed(() => isFullscreen.value ? t('fullscreen.close') : t('fullscreen.open'))
const showButton = computed(() => (browserWidth.value && browserWidth.value > buttonBreakpoint) || isFullscreen.value)

onMounted( () => {
  if (isSupported()) {
    addEventListener('fullscreenchange', onFullscreenChange)
    setCurrentFullscreenState()
    addEventListener('resize', updateWidth)
    updateWidth()
  }
})

onUnmounted(() => {
  if (isSupported()) {
    removeEventListener('fullscreenchange', onFullscreenChange)
    removeEventListener('resize', updateWidth)
    disableFullscreen()
  }
})

const updateWidth = () => {
  browserWidth.value = window.innerWidth
}

watch(isFullscreen, (value) => emit('fullscreen', value))
</script>

<template>
  <KsButton
    v-if="isSupported() && showButton"
    variant="secondary"
    shape="round"
    size="large"
    :aria-label="ariaLabel"
    :icon-left="isFullscreen ? 'compress' : 'expand'"
    @click="toggleFullscreen"
  />
</template>
